import { baseAPIRequest } from 'utilities/http';

function getSignInSetup () {

	return baseAPIRequest({ url: '/account/popups/sign-in/setup/', params: { method: 'GET' } });

}

export default getSignInSetup;
